import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import { FaTiktok, FaWhatsapp, FaInstagram, FaFacebook } from "react-icons/fa";
import { Mail, Phone } from "lucide-react";
import "../../App.css";

import logoAlbina from "../../assets/logo.png"; 

export default function Footer() {
  return (
    <footer className="footer-dark">
      <Container className="py-5">
        <Row className="gy-5">
          
          {/* Col 1: Logo, Descriere, Contact și Social Media */}
          <Col lg={4} md={12} className="pe-lg-5">
            {/* Logo Section */}
            <div className="d-flex align-items-center mb-4">
              <img
                src={logoAlbina}
                alt="PRDP"
                className="footer-logo-img me-3"
              />
              <span className="footer-brand-text">PRDP</span>
            </div>
            
            {/* Descriere */}
            <p className="footer-description mb-4">
              Construim o Românie Dreaptă și Prosperă, bazată pe meritocrație, transparență și respect pentru fiecare cetățean.
            </p>

            {/* Contact rapid */}
            <div className="footer-contact-info mb-4">
              <div className="d-flex align-items-center mb-2">
                <Mail size={18} className="me-3 contact-icon-yellow" />
                <a href="mailto:contact@prdp.ro" className="footer-link">contact@prdp.ro</a>
              </div>
              <div className="d-flex align-items-center">
                <Phone size={18} className="me-3 contact-icon-yellow" />
                <a href="tel:+40753339849" className="footer-link">+40 753 339 849</a>
              </div>
            </div>

            {/* Social Icons */}
            <div className="footer-social-icons d-flex gap-3">
              <a href="https://www.tiktok.com/@partidulprdp" aria-label="TikTok" className="social-icon">
                <FaTiktok size={20} />
              </a>
              <a href="https://instagram.com/partidulprdp" aria-label="Instagram" className="social-icon">
                <FaInstagram size={20} />
              </a>
              <a href="https://wa.me/+400753339849" aria-label="Whatsapp" className="social-icon">
                <FaWhatsapp size={20} />
              </a>
              <a href="https://www.facebook.com/partidulprdp" aria-label="Facebook" className="social-icon">
                <FaFacebook size={20} />
              </a>
            </div>
          </Col>

          {/* Col 2: Linkuri rapide (Puse una sub alta, într-o singură listă) */}
          <Col lg={4} md={6}>
            <h5 className="footer-heading">Linkuri rapide</h5>
            <div className="footer-heading-line mb-4"></div>
            
            <ul className="footer-links-list">
              <li><a href="https://prdp.ro">Acasă</a></li> <br/>
              <li><a href="/">Proiecte</a></li> <br/>
              <li><a href="https://prdp.ro/donatii">Donează</a></li> <br/>
              <li><a href="/contact">Contact</a></li>
            </ul>
          </Col>

          {/* Col 3: Informează-te & Status */}
          <Col lg={4} md={6}>
            <h5 className="footer-heading">Informează-te</h5>
            <div className="footer-heading-line mb-4"></div>
            
            {/* Le-am pus și pe acestea una sub alta, cu același spațiu */}
            <ul className="footer-links-list mb-4">
              <li><a href="/gdpr" className="footer-link">Prelucrarea datelor (GDPR)</a></li> <br/>
              <li><a href="/cookies" className="footer-link">Politică cookie-uri</a></li>
            </ul>

            {/* Badge-ul de status */}
            <div className="status-badge d-inline-flex align-items-center">
              <span className="status-dot me-2"></span>
              Toate sistemele funcționează
            </div>
          </Col>

        </Row>
      </Container>

      {/* Partea de jos (Copyright) */}
      <div className="footer-bottom py-4">
        <Container>
          <div className="d-flex flex-column flex-md-row justify-content-between align-items-center">
            <div className="footer-copyright mb-2 mb-md-0">
              © 2026 Partidul România Dreaptă și Prosperă. Toate drepturile rezervate.
            </div>
            <div className="footer-powered">
              Powered by <a href="https://joinstack.tech" target="_blank" rel="noopener noreferrer" className="fw-bold text-white joinstack-link">Joinstack Technology</a>
            </div>
          </div>
        </Container>
      </div>
    </footer>
  );
}